import { BehaviorSubject, debounceTime, Subscription } from "rxjs";
import { distinctUntilChanged } from "rxjs";

const query = new BehaviorSubject("");

/**
 *
 * @param observer {function}
 * @return {Subscription}
 */
export function searchKeywordChanges(observer = () => {
}) {
  return query.pipe(debounceTime(500), distinctUntilChanged())
    .subscribe(observer);
}

export function addSearchKeyword(value = "") {
  query.next(value);
}

export function clearSearchKeyword() {
  query.next("");
}